<template>
  <div>
    <el-row>
      <el-col :span="4">
        <span>领料日期：{{ pickingDay }}</span>
      </el-col>
      <el-col :span="4">
        <span>部门：{{ departmentName }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form size="small" :inline="true" class="demo-form-inline" style="margin-top: 20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" @keyup.enter.native="handleSearch()" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)" :loading="loading">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-badge :value="pickedProductsList.length" class="item" type="primary">
              <el-button size="medium" @click="pickedProductsVisible = !pickedProductsVisible" :loading="loading">
                已领产品
              </el-button>
            </el-badge>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="70"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="70"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价" min-width="70"></el-table-column>
          <el-table-column prop="TAX_RATE" label="税率" min-width="70"></el-table-column>
          <el-table-column prop="BATCH" label="批次" min-width="70"></el-table-column>
          <el-table-column prop="PRODUCTION_DATE" label="生产日期" min-width="70"></el-table-column>
          <el-table-column label="保质期" min-width="70">
            <template slot-scope="scope">
              <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="库存数量" min-width="45"></el-table-column>
          <el-table-column prop="PRODUCT_WORTH" label="剩余价值" min-width="45"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="addShopCar(scope.row)" type="text">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <!-- 进界面弹出的模态框 -->
        <el-dialog title="领料信息" :visible.sync="pickingFormVisible" width="30%" center :close-on-click-modal="false"
          :show-close="false">
          <el-form :ref="pickingForm" :model="pickingForm" label-width="100px" style="text-align: inherit;margin: 0">
            <el-form-item label="领料部门：">
              <el-select filterable v-model="pickingForm.department" style="width: 100%" :disabled="isDisabled">
                <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="领料日期：">
              <el-date-picker v-model="pickingForm.date" align="right" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd" :picker-options="pickerOptions1" style="width: 100%" :disabled="isDisabled">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closePicking">取 消</el-button>
            <el-button @click="submitInfo('secondForm')">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 加入购物车模态框 -->
        <el-dialog title="添加商品" :visible.sync="addFormVisible" width="30%" center>
          <el-form :ref="addForm" :model="addForm" label-width="100px" style="text-align: inherit;margin: 0">
            <el-form-item label="领料数量：">
              <el-input v-model="addForm.COUNT"></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="addForm.COMMENT"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addFormVisible = false">取 消</el-button>
            <el-button @click="submitAdd('secondForm')">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 已领产品 -->
        <el-drawer title="已领产品" :visible.sync="pickedProductsVisible" size="50%" class="spec-drawer">
          <el-table :data="pickedProductsList" stripe border style="margin-bottom: 10px; width: 100%">
            <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位" min-width="20"></el-table-column>
            <el-table-column prop="PRODUCT_BATCH" label="批次"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="数量" min-width="35">
              <template slot-scope="scope">
                <el-input v-model="scope.row.editCount" @blur="getProductTotalPrice(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="35"></el-table-column>
            <el-table-column label="操作" min-width="25">
              <template slot-scope="scope">
                <el-button @click="deletePickedProduct(scope.row)" type="text">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <span style="float: left; margin-left: 2.5%; display: block; height: 40px; line-height: 40px;">
            购物车总金额：{{ this.totalPrice }}
          </span>
          <el-button @click="submitEdit" style="float: right; margin-right: 2.5%">
            立即领料
          </el-button>
          <el-button @click="__clean" style="float: right; margin-right: 2.5%">
            清空购物车
          </el-button>
        </el-drawer>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryWarehouseFun } from 'api/warehouseManager';
import {
  getShopCarFun, addRecord, addShopCarFun, shopCarDetail, deleteShopDetail, editShopCarFun, clearShopCarFun,
} from 'api/proDepartment';
import { queryDepartment } from 'api/productDepart';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      loading: false,
      showStatus: 0,
      showAll: true,
      searchForm: {},
      total_price: 0,
      tableData: [],
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      pickingFormVisible: true,
      pickingForm: {},
      pickerOptions1: [],
      pickingDepart: '',
      pickingDay: '',
      departmentList: [],
      isDisabled: false,
      shopCarFlag: 0,
      CART_ID: 0,
      addForm: {},
      addFormVisible: false,
      departmentName: '',
      pickedProductsList: [],
      pickedProductsVisible: false,
      totalPrice: 0,
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryShopCar();
    this.queryDepartment();
    this.queryPickedProductsList();
  },
  methods: {
    // 判断购物车是否存在商品
    queryShopCar() {
      const params = {};
      getShopCarFun(params).then((result) => {
        if (result[0]) {
          this.pickingDay = result[0].ORDER_DATE;
          this.departmentName = result[0].DEPARTMENT_NAME;
          this.pickingForm.date = result[0].ORDER_DATE;
          this.isDisabled = true;
          this.shopCarFlag = 1;
          this.CART_ID = result[0].ID;
        } else {
          this.isDisabled = false;
          this.shopCarFlag = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选库存中商品
    handleSearch() {
      const params = {
        PRODUCT_NAME: this.searchForm.name,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: this.showStatus,
        FLAG: 0,
      };
      this.loading = true;
      queryWarehouseFun(params)
        .then((result) => {
          this.totalCount = result[0].TOTAL_COUNT;
          this.tableData = result[0].OP_ROLE.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) }))
            .map((item, index) => Object.assign(item, { CXCOUNT: item.CXCount }));
          if (result[0].TOTAL_WORTH !== '') {
            this.total_price = result[0].TOTAL_WORTH;
          } else {
            this.total_price = 0;
          }
          this.loading = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.loading = false;
        });
    },
    // 提交领料信息模态框
    submitInfo() {
      if (this.shopCarFlag == 1) {
        this.pickingFormVisible = false;
      } else {
        const params = {
          ORDER_DATE: this.pickingForm.date,
          DEPARTMENT_ID: this.pickingForm.department,
        };
        addRecord(params).then((result) => {
          this.pickingFormVisible = false;
          this.pickingDay = this.pickingForm.date;
          const tmp = this.departmentList.find((item) => item.ID == this.pickingForm.department);
          this.departmentName = tmp.DEPARTMENT_NAME;
          this.CART_ID = result[0].ID;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    // 加购物车
    addShopCar(row) {
      this.addFormVisible = true;
      this.addForm = row;
    },
    submitAdd() {
      // 正则：正数
      const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      // 正则：正整数
      const reg2 = /^\d+(\.0+)?$/;
      if (util.JudgmentUnit(this.addForm.TYPE_UNIT)) {
        if (!reg1.test(this.addForm.COUNT)) {
          this.$message.show({ text: '请输入正数领料数量', type: 'warning' });
          return false;
        }
      } else if (!reg2.test(this.addForm.COUNT)) {
        this.$message.show({ text: '请输入正整数领料数量', type: 'warning' });
        return false;
      }
      const params = {
        CART_ID: this.CART_ID,
        PRODUCT_COUNT: this.addForm.COUNT,
        PRODUCT_COMMENT: this.addForm.COMMENT,
        PRODUCT_BATCH: this.addForm.BATCH,
      };
      addShopCarFun(params).then((res) => {
        this.$message.show({ text: '添加成功', type: 'success' });
        this.addFormVisible = false;
        this.addForm = {};
        this.queryPickedProductsList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.handleSearch();
    },
    closePicking() {
      this.$router.back();
    },
    queryDepartment() {
      queryDepartment().then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取购物车已领产品
    queryPickedProductsList() {
      const data = {};
      shopCarDetail(data).then((result) => {
        if (result[1].PRODUCTS_IN_SC.length === 0) {
          this.pickedProductsList = [];
        } else {
          for (let i = 0; i < result[1].PRODUCTS_IN_SC.length; i++) {
            result[1].PRODUCTS_IN_SC[i].editCount = result[1].PRODUCTS_IN_SC[i].PRODUCT_COUNT;
          }
          this.pickedProductsList = result[1].PRODUCTS_IN_SC;
        }
        if (result[0].TITILE.length !== 0) {
          this.totalPrice = result[0].TOTAL_FEE === '' ? 0.00 : result[0].TOTAL_FEE;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    async submitEdit() {
      // 正则：正数
      const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      // 正则：正整数(后面可以跟.0000)
      const reg2 = /^\d+(\.0+)?$/;
      console.log(this.pickedProductsList);
      if (this.pickedProductsList.every((item) => {
        if (Number(item.editCount) > Number(item.OLD_COUNT)) {
          this.$message.show({ text: '领料数量不得超出库存数量', type: 'warning' });
          return false;
        }
        if (util.JudgmentUnit(item.TYPE_UNIT)) {
          if (!reg1.test(item.editCount)) {
            this.$message.show({ text: '请输入正数领料数量', type: 'warning' });
            return false;
          }
          return true;
        }
        if (!reg2.test(item.editCount)) {
          this.$message.show({ text: '请输入正整数领料数量', type: 'warning' });
          return false;
        }
        return true;
      })) {
        for (let i = 0; i < this.pickedProductsList.length; i++) {
          if (this.pickedProductsList[i].PRODUCT_COUNT != this.pickedProductsList[i].editCount) {
            const params = {
              CART_DETAIL_ID: this.pickedProductsList[i].ID,
              PRODUCT_COUNT: this.pickedProductsList[i].editCount,
              PRODUCT_COMMENT: this.pickedProductsList[i].COMMENT,
            };
            console.log(params);
            // eslint-disable-next-line no-await-in-loop
            await editShopCarFun(params).then((_res) => { }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
          }
        }
        setTimeout(() => { this.$router.push({ name: 'proPickingShopCar' }); }, 500);
      }
    },
    // 删除已领产品
    deletePickedProduct(row) {
      const data = {
        CART_DETAIL_ID: row.ID,
      };
      deleteShopDetail(data)
        .then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryPickedProductsList();
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    getProductTotalPrice(row) {
      row.productTotalPrice = (Number(row.editCount) * Number(row.PRODUCT_PRICE)).toFixed(2);
      console.log(row);
    },
    // 清空购物车
    __clean() {
      const params = {
        CART_ID: this.CART_ID,
      };
      clearShopCarFun(params).then((result) => {
        this.$message.show({ text: '清空成功', type: 'success' });
        // 初始化数据
        this.pickedProductsList = [];
        this.TOTAL_FEE = 0.00;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
div>>>.pagination_box {
  float: right;
}

.spec-drawer /deep/ .el-drawer__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(100vh - 140px);
}
</style>



// WEBPACK FOOTER //
// src/components/productionProcessing/proPickingProduct.vue